import React from "react";

const ScreenshotRemoveIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="12" fill="#000" />
    <circle cx="12" cy="12" r="6.5" stroke="#fff" strokeWidth="1.5" />
    <path
      d="m9.6 9.6 4.8 4.8m0-4.8-4.8 4.8"
      stroke="#fff"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default ScreenshotRemoveIcon;
